"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var dateTimeFormatter_1 = require("./dateTimeFormatter");
var ChartDisplayRangeFormats = {
    HOURS: { hour: "2-digit", minute: "2-digit" },
    DAYS: { month: "short", day: "2-digit" },
    MONTHS: { month: "short", year: "numeric" },
};
var TooltipDisplayRangeFormats = {
    HOURS: { month: "short", day: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" },
    DAYS: { month: "short", day: "2-digit", year: "numeric" },
    MONTHS: { month: "short", year: "numeric" },
};
function formatDate(value, range, context, language, timezone) {
    if (!language) {
        language = __1.getBrowserLanguage();
    }
    var formats = context === "CHART" ? ChartDisplayRangeFormats : TooltipDisplayRangeFormats;
    var format = formats[range];
    return dateTimeFormatter_1.customLocale(value, language, format, timezone);
}
exports.formatDate = formatDate;
